import { useState } from 'react'
import { useMutation } from 'convex/react'
import { api } from './api'
import type { Id } from './api'

/** Upload a file to Convex storage; returns the storageId. */
export function useUpload() {
  const generateUploadUrl = useMutation(api.storage.generateUploadUrl)
  const [uploading, setUploading] = useState(false)

  async function upload(file: File): Promise<Id<'_storage'>> {
    setUploading(true)
    try {
      const url = await generateUploadUrl()
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': file.type },
        body: file,
      })
      if (!res.ok) throw new Error('Upload failed')
      const { storageId } = (await res.json()) as { storageId: Id<'_storage'> }
      return storageId
    } finally {
      setUploading(false)
    }
  }

  return { upload, uploading }
}
